<script>
import NotificationBubble from '@components/notifications/notification-bubble.vue';
import { authComputed, prospectComputed } from '@state/helpers';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  components: {
    NotificationBubble,
  },
  props: {
    route: {
      type: Object,
      required: false,
      default: null,
    },
    routeArr: {
      type: Array,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
  },
  mixins: [clickaway],
  data() {
    return {
      placeholder: require('@assets/images/placeholder-avatar.png'),
      showDropdownMenu: false,
      mouseOver: '',
    };
  },
  computed: {
    ...authComputed,
    ...prospectComputed,
    isAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isAdmin
      );
    },
    fitnessRoutes() {
      return this;
    },
    isChildActive() {
      if (this.routeArr && this.routeArr.length > 0) {
        const currentRouteName = this.$route.name;
        return this.routeArr.find((route) => route.name === currentRouteName);
      } else {
        return false;
      }
    },
    showMsgBubble() {
      return this.type && this.type === 'business' && this.hasUnreadMessages;
    },
    hasUnreadMessages() {
      return this.prospectsRepliedCount > 0;
    },
  },
  mounted() {},
  methods: {
    getRouteTitle(route) {
      return typeof route.title === 'function' ? route.title() : route.title;
    },
    getMainRoute(routeArr) {
      return routeArr && routeArr.length > 0 ? routeArr[0] : {};
    },
    getMainRouteName(routeArr) {
      return routeArr && routeArr.length > 0
        ? typeof routeArr[0].title === 'function'
          ? routeArr[0].title()
          : routeArr[0].title
        : null;
    },
    onMouseover() {
      if (this.routeArr && this.routeArr.length > 1) {
        this.showDropdownMenu = true;
      }
    },
    onMouseleave() {
      if (this.routeArr && this.routeArr.length > 1) {
        this.showDropdownMenu = false;
      }
    },
    clickedOutside() {
      this.showDropdownMenu = false;
    },
  },
};
</script>

<template>
  <div>
    <li
      :class="{
        'router-link-active': isChildActive,
        'pending-messages': hasUnreadMessages,
      }"
      v-if="routeArr && routeArr.length > 0"
      @mouseover="onMouseover"
      @mouseleave="onMouseleave"
    >
      <NotificationBubble
        v-if="showMsgBubble"
        :minimal="true"
        :noBorder="true"
      />
      <a
        >{{
          route
            ? getRouteTitle(route)
            : type && type === 'business'
            ? 'My Business'
            : type && type === 'nutrition'
            ? 'FUEL'
            : type && type === 'fitness'
            ? 'TRAIN'
            : ''
        }}
      </a>
      <div
        v-on-clickaway="clickedOutside"
        class="profile-links"
        v-if="routeArr && showDropdownMenu"
      >
        <div class="profile-dropdown-menu">
          <ul>
            <template v-for="subRoute in routeArr">
              <router-link :key="subRoute.name" :to="subRoute" tag="li">
                <span class="link-text">{{ getRouteTitle(subRoute) }}</span>
                <NotificationBubble
                  type="count"
                  :content="prospectsRepliedCount"
                  :key="subRoute.name"
                  v-if="showMsgBubble && getRouteTitle(subRoute) === 'Grow'"
                />
              </router-link>
            </template>
          </ul>
        </div>
      </div>
    </li>
    <BaseLink v-if="route" tag="li" :to="route">
      <a>{{ getRouteTitle(route) }}</a>
    </BaseLink>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type

li.pending-messages {
  position: relative;

  .notification-bubble {
    background-color: $color-red;
    left: -1.3rem;
    margin-left: 0;
    position: absolute;
    top: 0.85rem;
  }
}

.profile-links {
  position: absolute;

  .profile-dropdown-menu {
    border: 0;
    border-radius: 0;
    box-shadow: 0 0.2rem 0.4rem rgba($color-black-wo-rgb, 0.08);
    float: left;
    font-size: 1rem;
    min-height: 12rem;
    min-width: 22rem;
    padding-top: 2.1rem;
    position: absolute;
    text-align: left;
    z-index: 1000;

    li {
      align-items: center;
      background-color: $color-black-one;
      box-shadow: 0 4px 4px rgba($color-black-wo-rgb, 0.25),
        0 0 16px rgba($color-black-wo-rgb, 0.37);
      color: white;
      display: flex;
      font-family: $base-font-family;
      font-size: 13px;
      font-style: normal;
      font-weight: 800;
      height: 4.5rem;
      letter-spacing: 1.05px;
      line-height: 22px;
      padding: 0.5rem 1rem;
      padding: 3rem;
      position: relative;
      text-transform: uppercase;
      width: 100%;

      &.router-link-active span.link-text {
        border-bottom: 3px solid $color-action;
        color: $color-navbar-link-text-active !important;
        padding-bottom: 0.5rem;
      }

      &:hover {
        background-color: rgb(80, 80, 80);
        cursor: pointer;
      }

      .notification-bubble {
        background-color: $color-red;
        left: 9rem;
        margin-left: 0;
        position: absolute;
        top: 2rem;
      }
    }
  }
}
</style>
